"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CopyToClipboard;

var _react = _interopRequireWildcard(require("react"));

var _FileCopyOutlined = _interopRequireDefault(require("@material-ui/icons/FileCopyOutlined"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      width: "100%"
    },
    input: {
      border: "none",
      background: "transparent",
      width: "100%",
      "&:focus": {
        outline: "none"
      }
    }
  };
});

function CopyToClipboard(_ref) {
  var value = _ref.value;
  var classes = useStyles();
  var inText = (0, _react.useRef)();

  var handleCopy = function handleCopy(e) {
    inText.current.select();
    document.execCommand("copy");
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "copy to clipboard",
    onClick: handleCopy
  }, /*#__PURE__*/_react["default"].createElement(_FileCopyOutlined["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement("input", {
    className: classes.input,
    onClick: handleCopy,
    ref: inText,
    type: "text",
    value: "".concat(value),
    readOnly: true
  }));
}

CopyToClipboard.propTypes = {
  /**
   * String to copy
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};